jQuery(document).ready(function( $ ) {

  // wrap nav
  $('ul.sub-menu').wrap('<div class="pc-dropdown-wrapper"></div>');
  var x = window.matchMedia("(max-width: 1030px)");
  if (x.matches===true) {
    //toggle sub-menu on mobile
    $('.pc-main-nav li.menu-item-has-children > a').on('click',function(e){

    e.preventDefault();
    $(this).parent().toggleClass('open');
  });
  }

});
